const footerLinks = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Contact", href: "#contact" },
];

const legalLinks = [
  { label: "Legal", href: "#" },
  { label: "Privacy", href: "#" },
  { label: "Disclosures", href: "#" },
];

export default function Footer() {
  const handleNav = (href: string) => {
    if (href === "#") return;
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="w-full bg-[#060606] border-t border-white/8">
      {/* Upper */}
      <div className="max-w-6xl mx-auto px-5 sm:px-8 md:px-16 py-12 sm:py-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 sm:gap-12">
        {/* Brand */}
        <div className="sm:col-span-2 md:col-span-1">
          <img
            src="https://static.readdy.ai/image/b9776ec7c1da350797bd71cdecd03ae9/ad8efe877ad37fb904eb80ba5955f67a.jpeg"
            alt="Logo"
            className="h-10 sm:h-12 w-auto object-contain mb-5 sm:mb-6"
          />
          <p className="text-white/35 text-xs leading-relaxed max-w-xs">
            A private investment firm focused on strategic acquisitions and cross-border capital solutions across global markets.
          </p>
          <div className="flex gap-3 mt-6 sm:mt-8">
            {["ri-linkedin-line", "ri-twitter-x-line", "ri-global-line"].map((icon) => (
              <a
                key={icon}
                href="#"
                rel="nofollow"
                className="w-8 h-8 flex items-center justify-center border border-white/15 text-white/40 hover:border-[#c9a84c]/50 hover:text-[#c9a84c] transition-all duration-300 cursor-pointer"
              >
                <i className={`${icon} text-sm`} />
              </a>
            ))}
          </div>
        </div>

        {/* Navigation */}
        <div>
          <p className="text-[#c9a84c] text-[10px] tracking-[4px] uppercase mb-5 sm:mb-6">Navigation</p>
          <ul className="space-y-3">
            {footerLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                  className="text-white/40 text-xs tracking-[1px] hover:text-[#c9a84c] transition-colors duration-300 cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact info */}
        <div>
          <p className="text-[#c9a84c] text-[10px] tracking-[4px] uppercase mb-5 sm:mb-6">Contact</p>
          <div className="space-y-4">
            <div>
              <p className="text-white/25 text-[10px] tracking-[2px] uppercase mb-1">Address</p>
              <p className="text-white/45 text-xs leading-relaxed">Berkeley House<br />Berkeley Square, Mayfair<br />London</p>
            </div>
            <div>
              <p className="text-white/25 text-[10px] tracking-[2px] uppercase mb-1">Telephone</p>
              <p className="text-white/45 text-xs">+44 7880 888090</p>
            </div>
            <div>
              <p className="text-white/25 text-[10px] tracking-[2px] uppercase mb-1">Email</p>
              <p className="text-white/45 text-xs break-all">enquiries@88elevencapital.com</p>
            </div>
          </div>
        </div>
      </div>

      {/* Lower bar */}
      <div className="border-t border-white/8 px-5 sm:px-8 md:px-16 py-5 sm:py-6 flex flex-col items-center gap-4 sm:gap-3">
        {/* Powered by — always centered */}
        <div className="flex items-center gap-2">
          <p className="text-white/50 text-[11px] tracking-[2px] uppercase text-center">
            Powered by proprietary{" "}
            <a
              href="https://theaqaris.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-[#c9a84c] hover:text-[#e0c070] transition-colors duration-300 cursor-pointer"
            >
              AQARIS
            </a>
            <sup className="text-[9px] text-[#c9a84c]">TM</sup> Intelligence
          </p>
        </div>

        {/* Bottom row: copyright + legal */}
        <div className="w-full flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/25 text-[11px] tracking-[1px] text-center sm:text-left">
            &copy; 2026 Capital Investment Group. All rights reserved.
          </p>
          <div className="flex items-center gap-4 sm:gap-6 flex-wrap justify-center">
            {legalLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                rel="nofollow"
                className="text-white/30 text-[11px] tracking-[1px] hover:text-[#c9a84c] transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
